import { ServerTransactionByIdType } from '@expane/data'
import { convertUnitValueFromServer } from '../../product'
import { filterMovementProductsWithoutInServiceConsumables } from './filters'

export interface ItemToRefundByPaymentProvider {
  type: 'card' | 'service' | 'product'
  id: number
  position: string
  price: number
  amount: number
  quantity: number
  unit?: number
}

// Абонементи й сертифікати поки показуємо по одному, бо й нема логіки продажу більше ніж одного за раз
export const extractCardsFromTransactionForRefund = (
  transactionById: ServerTransactionByIdType,
) => {
  const cards: ItemToRefundByPaymentProvider[] = []

  for (const { discount, card, price } of transactionById.transactionsCards) {
    const amount = price - (discount || 0)

    cards.push({
      id: card.id,
      type: 'card',
      position: card.cardTemplate.name,
      price: amount,
      amount,
      quantity: 1,
    })
  }

  return cards
}

// Послуги можуть бути продані тільки всередині запису, тому вони є унікальними
export const extractServicesFromTransactionForRefund = (
  transactionById: ServerTransactionByIdType,
) => {
  const services: ItemToRefundByPaymentProvider[] = []

  for (const { discount, service, price } of transactionById.transactionsServices) {
    const amount = price - (discount || 0)

    services.push({
      id: service.id,
      type: 'service',
      position: service.name,
      price: amount,
      amount,
      quantity: 1,
    })
  }

  return services
}

export const extractConsumablesFromTransactionForRefund = (
  transactionById: ServerTransactionByIdType,
) => {
  const products: ItemToRefundByPaymentProvider[] = []

  const movementProductsWithoutInServiceConsumable =
    filterMovementProductsWithoutInServiceConsumables(transactionById)

  for (const movementProduct of movementProductsWithoutInServiceConsumable) {
    const price = movementProduct.price - (movementProduct.discount || 0)
    const amount =
      price * convertUnitValueFromServer(movementProduct.quantity, movementProduct.product.unit)

    products.push({
      id: movementProduct.productId,
      type: 'product',
      position: movementProduct.product.name,
      price,
      amount,
      quantity: movementProduct.quantity,
      unit: movementProduct.product.unit,
    })
  }

  return products
}

export const calcItemsToRefundByPaymentProviderTotalPrice = (
  items: ItemToRefundByPaymentProvider[],
) =>
  items.reduce((sum, item) => {
    return item.amount + sum
  }, 0)
